import clientAuth from "../clientAuth";

export default {
  index: () => clientAuth.get("feature/index"),
  
  store: (userData) => clientAuth.post('feature/store', { json: userData }),
  

  show:(id)=>clientAuth.get('feature/show/'+id),

  update:(id,userData)=>clientAuth.post('feature/update/'+id,{json:userData}),

  destroy:(id)=>clientAuth.delete(`feature/destroy/${id}`),
};